/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type {
  AddVoteRequest,
  CreateConfidenceVoteSessionRequest,
  CreateConfidenceVoteSessionResponse,
  EndConfidenceVoteSessionResponse,
  GetConfidenceVoteSessionsRequest,
  GetConfidenceVoteSessionsResponse,
  GetMyVoteResponse,
  GetParticipantsResponse,
  JoinConfidenceVoteSessionResponse,
  NoData,
  StartConfidenceVoteSessionResponse,
  UpdateConfidenceVoteSessionRequest,
  UpdateConfidenceVoteSessionResponse,
} from "./models";
import {
  createConfidenceVoteSessionResponseSchema,
  endConfidenceVoteSessionResponseSchema,
  getConfidenceVoteSessionsResponseSchema,
  getMyVoteResponseSchema,
  getParticipantsResponseSchema,
  joinConfidenceVoteSessionResponseSchema,
  noDataSchema,
  startConfidenceVoteSessionResponseSchema,
  updateConfidenceVoteSessionResponseSchema,
} from "./schemas";

export class ConfidenceVoteApiClient {
  constructor(private caller: ApiCaller) {}

  async createSession(
    payload: CreateConfidenceVoteSessionRequest,
    timeout?: number,
  ): Promise<CreateConfidenceVoteSessionResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.create",
        variables: {},
      },
      "createSession",
      payload,
      { schema: createConfidenceVoteSessionResponseSchema, timeout },
    );
  }

  async endSession(
    votingSessionId: string,
    timeout?: number,
  ): Promise<EndConfidenceVoteSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.${votingSessionId}.end",
        variables: { votingSessionId: String(votingSessionId) },
      },
      "endSession",
      {},
      { schema: endConfidenceVoteSessionResponseSchema, timeout },
    );
  }

  async joinSession(
    votingSessionId: string,
    timeout?: number,
  ): Promise<JoinConfidenceVoteSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.${votingSessionId}.join",
        variables: { votingSessionId: String(votingSessionId) },
      },
      "joinSession",
      {},
      { schema: joinConfidenceVoteSessionResponseSchema, timeout },
    );
  }

  async getParticipants(
    votingSessionId: string,
    timeout?: number,
  ): Promise<GetParticipantsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.${votingSessionId}.participants.get",
        variables: { votingSessionId: String(votingSessionId) },
      },
      "getParticipants",
      {},
      { schema: getParticipantsResponseSchema, timeout },
    );
  }

  async searchSessions(
    payload: GetConfidenceVoteSessionsRequest,
    timeout?: number,
  ): Promise<GetConfidenceVoteSessionsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.search",
        variables: {},
      },
      "searchSessions",
      payload,
      { schema: getConfidenceVoteSessionsResponseSchema, timeout },
    );
  }

  async addVote(
    payload: AddVoteRequest,
    votingSessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.${votingSessionId}.votes.add",
        variables: { votingSessionId: String(votingSessionId) },
      },
      "addVote",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getMyVote(votingSessionId: string, timeout?: number): Promise<GetMyVoteResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.${votingSessionId}.my_vote.get",
        variables: { votingSessionId: String(votingSessionId) },
      },
      "getMyVote",
      {},
      { schema: getMyVoteResponseSchema, timeout },
    );
  }

  async deleteSession(votingSessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.${votingSessionId}.delete",
        variables: { votingSessionId: String(votingSessionId) },
      },
      "deleteSession",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async updateSession(
    payload: UpdateConfidenceVoteSessionRequest,
    votingSessionId: string,
    timeout?: number,
  ): Promise<UpdateConfidenceVoteSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.${votingSessionId}.update",
        variables: { votingSessionId: String(votingSessionId) },
      },
      "updateSession",
      payload,
      { schema: updateConfidenceVoteSessionResponseSchema, timeout },
    );
  }

  async startSession(
    votingSessionId: string,
    timeout?: number,
  ): Promise<StartConfidenceVoteSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.confidence_vote.v1.sessions.${votingSessionId}.start",
        variables: { votingSessionId: String(votingSessionId) },
      },
      "startSession",
      {},
      { schema: startConfidenceVoteSessionResponseSchema, timeout },
    );
  }
}
